module.exports = __webpack_public_path__ + "img/f2-1.fc8e64b5.png";